import { Button, Card, Form, Input, Select, Spin } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import DocumentList from "../../components/DocumentList";

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      documentData: [],
    };
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      const data = Object.assign({}, values);
      const { documentData } = this.state;
      // data.documents = documentData;
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, subDocumentFilters, form } = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} Sub Location`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (filters[item] && filters[item].options && filters[item].options.hidden) {
                return;
              }
              if (filters[item].type === 'ObjectID' && item === 'vendor') {
                return getFormFieldByType(filters, item, getFieldDecorator, data, { title: title, resource });
              }

              if (item === 'geoLocations') {
                return;
              }

              if (filters[item].type === 'String') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: true, message: `${item} is required!` }],
                    initialValue: item !== 'password' ? data && data[item] : ''
                  })(<Input />)
                  }
                </Form.Item>
              }

              if (filters[item].type === 'Array' && item !== 'documents') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: true, message: `${sanitizeFieldName(item)} is required!` }],
                    initialValue: (data && data[item]) ? data[item].map(field => field._id) : []
                  })(<Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Please select"
                  >
                    {filters[item] && filters[item].data && filters[item].data.data && filters[item].data.data.map(item =>
                      <Select.Option key={item._id}
                        value={item._id}>{item.role}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              }

              // if(filters[item].type === 'Array' && filters[item].options.ref) {
              //   return <DocumentList match={this.props.match} history={this.props.history} key={item}
              //                        item={filters[item]} form={form} data={data[item]}
              //                        subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData}/>
              // }

              if (filters[item].type === 'Number') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    initialValue: data && data[item]
                  })(<Input type='number' />)
                  }
                </Form.Item>
              }

              return null;

            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
